<template>
  <!-- ケアオーケストレーター施設管理 -->
  <div id="COSettingHospital">
    <div id="container-center">
      <coSettingNavi v-bind:pageid='"COSettingHospital"' :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId' :certificationFlag='this.certificationFlag' :searchConditions='this.searchConditions'></coSettingNavi>
      <settingHospital :careOrchestratorInstitutionId='this.careOrchestratorInstitutionId'  />
      <div style="margin-top:10px;">
          <b-button class="backbutton is-primary" @click="back">メニューに戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/guest/careorchestrator/SettingNaviBar";
import contents from "@/components/mock/guest/careorchestrator/setting/ExternalHospitalContents";

export default {
  name: "COSettingHospital",
  methods: {
    back: function() {
      this.$router.push({ path: "/guest/home" });
    },
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    let searchConditions = this.$route.params["searchConditions"]
    return {
      careOrchestratorInstitutionId : careOrchestratorInstitutionId,
      certificationFlag: certificationFlag,
      searchConditions, searchConditions  
    };
  },
  filters: {},
  components: {
    coSettingNavi: naviBar,
    settingHospital: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/COSettingHospital.vue